//--------------------------------
// load race characteristic props
//--------------------------------
export default function loadRaceCharacteristicProps(races) {
  console.log("------------------------------");
  console.log("IN loadRaceCharacteristicProps");
  //
  races.forEach((c) => {
    if (!Object.hasOwn(c, "str")) {
      Object.defineProperty(c, "str", {
        value: false,
        writable: true,
        enumerable: true,
        configurable: true,
      });
    }
    if (!Object.hasOwn(c, "con")) {
      Object.defineProperty(c, "con", {
        value: false,
        writable: true,
        enumerable: true,
        configurable: true,
      });
    }
    if (!Object.hasOwn(c, "dex")) {
      Object.defineProperty(c, "dex", {
        value: 0,
        writable: true,
        enumerable: true,
        configurable: true,
      });
    }
    if (!Object.hasOwn(c, "siz")) {
      Object.defineProperty(c, "siz", {
        value: 0,
        writable: true,
        enumerable: true,
        configurable: true,
      });
    }
    if (!Object.hasOwn(c, "int")) {
      Object.defineProperty(c, "int", {
        value: 0,
        writable: true,
        enumerable: true,
        configurable: true,
      });
    }
    if (!Object.hasOwn(c, "pow")) {
      Object.defineProperty(c, "pow", {
        value: 0,
        writable: true,
        enumerable: true,
        configurable: true,
      });
    }
    if (!Object.hasOwn(c, "cha")) {
      Object.defineProperty(c, "cha", {
        value: 0,
        writable: true,
        enumerable: true,
        configurable: true,
      });
    }
  });
  return races;
}
